<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <div class="text-right">
            <button @click="getInvoices" class="btn btn-outline-info btn-sm">Обновить заявки</button>
          </div>
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th>ID</th>
              <th>Препарат</th>
              <th>Поступление</th>
              <th width="95px">Бронь</th>
              <th>Заявки</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(drugData, drugId, i) in drugs" v-if="orders[drugId]">
              <td>{{ drugId }}</td>
              <td>{{ drugData.title }}</td>
              <td>
                <p>Наличие: <strong>{{ inStores[drugId] ?? 0}}</strong></p>
                <p v-for="inv in (incomeDrugs[drugId]?.invoices ?? [])"><strong>{{ +inv.qty }} уп.</strong>
                  {{ printDate(invoices[inv.invoice_id].delivery_date, 'DD.MM.YYYY') }}</p>
              </td>
              <td>
                <p>свбд: <strong>{{
                    (inStores[drugId] ?? 0) + (supplyDrugs[drugId] ?? 0) - (reserved[drugId] ?? 0)
                    }}</strong></p>
                <p>рзрв: <strong>{{ reserved[drugId] ?? 0 }}</strong></p>
              </td>
              <td>
                <template v-for="o in (orders[drugId] ?? [])">
                  <button @click="orderToEdit(o.id)" class="btn btn-xs btn-outline-info mb-1 mr-1">
                    <i class="icon-fa icon-fa-eye"></i> {{ o.id }} <strong v-if="o.is_reserved">резерв</strong>
                  </button>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      loading: false,
      drugs: {},
      incomeDrugs: {},
      invoices: {},
      orders: {},
      reservedDrugs: {},
      supplyDrugs: {},
      inStores: {},
      reserved: {},
    }
  },
  created() {
    this.getInvoices();
  },
  methods: {
    orderToEdit(id, dialog = null) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
    },

    async getInvoices() {
      this.loading = true;
      const {data} = await api.index('/invoices/manage/orders');
      if (data.success) {
        this.drugs = data.drugsData;
        this.incomeDrugs = data.incomeDrugs;
        this.inStores = data.inStores;
        this.invoices = data.invoices;
        this.reserved = data.reserved;
        this.orders = data.orders;
        this.supplyDrugs = Object.keys(data.incomeDrugs).reduce((acc, drugId) => {
          acc[drugId] = 0;
          Object.values(data.incomeDrugs[drugId].invoices).forEach((i) => {
            acc[drugId] += +i.qty;
          })
          return acc;
        }, {})
        // this.reservedDrugs = Object.keys(data.orders).reduce((acc, drugId) => {
        //   acc[drugId] = 0;
        //   data.orders[drugId].forEach((o) => {
        //     if (!o.is_reserved) return;
        //     o.details.forEach((d) => {
        //       if (d.drug_id === +drugId) {
        //         acc[drugId] += d.qty;
        //       }
        //     })
        //   })
        //   return acc;
        // }, {})
      }
      this.loading = false;
    }
  }
}

</script>
